import * as ActionType from '../utilities/ActionType';
import * as surveyServices from '../services/SurveyServices';
// import instrument from '../environments/instrument.json';

/**
 * Action to get session header
 *
 * @param { authorizationTokenGuid:string } authorizationTokenGuid
 *
 */
const getSessionHeader = (authorizationTokenGuid, dataCollectionGuid, dataCollectionGuidsCollection) => {
    return (dispatch) => {
        surveyServices.getSessionHeaderData(authorizationTokenGuid).then((response) => {
            if (response.data) {
                sessionStorage.setItem("authorizationGuid", JSON.stringify(response.data));

                dispatch({
                    "type":ActionType.GET_SESSION_HEADER,
                    "data":response.data
                });

            }
            let collection = {dataCollectionGuid, dataCollectionGuidsCollection}
            return collection;
        }).then((collection) => {
                var sessionHeader = JSON.parse(sessionStorage.getItem("authorizationGuid"));
                const { dataCollectionGuid, dataCollectionGuidsCollection } = collection;

                surveyServices.getAllResponseData(dataCollectionGuid, sessionHeader).then((response) => {
                    dispatch({
                        'type':ActionType.GET_ALL_ITEM_RESPONSE,
                        'data':response.data
                    })
                }).catch((error) => {
                    console.log("Exceptions: while getting all response in the action:_", error);
                });

            return collection
        }).then((collection) => {
            var sessionHeader = JSON.parse(sessionStorage.getItem("authorizationGuid"));
            const { dataCollectionGuidsCollection } = collection;

            surveyServices.getAllResponseForMutiple(dataCollectionGuidsCollection, sessionHeader).then((response) => {
                    dispatch({
                        'type':ActionType.GET_ALL_FOR_MULTIPLE_RESPONSE,
                        'data':response.data
                    })
                    if (response.data) {
                    setTimeout(() => {
                        dispatch(loadingSpinner(false));
                        }, 1000);
                    }
                }).catch((error) => {
                    console.log("Exceptions: while getting get all for multiple response in the action:_", error);
                })
        }).catch((error) => {
            console.log("Exceptions: while getting the session header in action:_", error);
        })
    }
}

/**
 * Action to get survey
 *
 * @param { formXmlGuid:string } formXmlGuid
 * @param { dataCollectionGuid:string } dataCollectionGuid
 *
 * @returns { object } object
 *
 */
const getSurvey = (formXmlGuid, dataCollectionGuid) => {
    return (dispatch) => {
        surveyServices.getSurveyData(formXmlGuid, dataCollectionGuid).then((response) => {
            dispatch({
                "type":ActionType.GET_SURVEY,
                "data":response.data
                // "data":instrument
            });

                // if (response.data) {
                //     setTimeout(() => {
                //         dispatch(loadingSpinner(false));
                //     }, 1000);
                // }
        }).catch((error) => {
            dispatch(loadingSpinner(false));
            if (error.message === "Network Error") {
                dispatch({
                    "type":ActionType.LOST_CONNECTION,
                    "data":navigator.onLine
                });
            }
            console.log("while getting survey in action:_", error);
        })
    }
}

/**
 * Action to get assessment information
 *
 * @param { dataCollectionGuid:string } dataCollectionGuid
 * @param { authorizationTokenGuid:string } authorizationTokenGuid
 *
 * @returns { object } object
 *
 */
const getAssessmentInfoForDataCollection = (dataCollectionGuid, authorizationTokenGuid) => {
    return (dispatch) => {
        surveyServices.getAssessmentInfoForDataCollection(dataCollectionGuid, authorizationTokenGuid).then((response) => {

            dispatch({
                "type":ActionType.GET_ASSESSMENT_INFO,
                "data":response.data
            });

        }).catch((error) => {
            console.log("Exceptions:while getting assessment info in action:_", error.message);
        })
    }
}

/**
 * Action to get assessment information
 *
 * @param { dataCollectionGuid:Array } dataCollectionGuid
 * @param { authorizationTokenGuid:string } authorizationTokenGuid
 *
 * @returns { object } object
 *
 */
 const getAssessmentInfosForDataCollection = (dataCollectionGuid, authorizationTokenGuid) => {
    return (dispatch) => {
        surveyServices.getAssessmentInfosForDataCollection(dataCollectionGuid, authorizationTokenGuid).then((response) => {
            dispatch({
                "type":ActionType.GET_ASSESSMENT_INFO_COL,
                "data":response.data
            });

        }).catch((error) => {
            console.log("Exceptions:while getting assessment info data collections in action:_", error.message);
        })
    }
}

/**
 * Action to put all the item response
 *
 * @param { dataCollectionGuid:object } dataCollectionGuid
 * @param { itemResponseSets:Array } itemResponseSets
 * @param { completion:string } completion
 *
 */
const putAllItemResponses = (dataCollectionGuid, itemResponseSets, completionStatus, type, elapsedTime, itemKey) => {
    return async (dispatch) => {

        surveyServices.putAllItemResponsesData(dataCollectionGuid, itemResponseSets, completionStatus, elapsedTime).then((response) => {
            if (typeof response.status !== undefined) {

                for (const key in itemResponseSets) {
                    if (itemResponseSets.hasOwnProperty(key)) {
                        itemResponseSets[key].hasPosted = 1;
                        itemResponseSets[key].serverStatus = response.status;
                    }
                }

                dispatch({
                    "type":ActionType.PUT_ALL_SUCCESS,
                    "data":{itemResponseSets, "status":response.status}
                });

                setTimeout(() => {
                    dispatch(isAPIUpdate(false));
                }, 0);

                if (type !== "itemChange") {
                    dispatch({
                        "type":ActionType.PUT_ALL_RESPONSE,
                        "data":response.data
                    });
                    setTimeout(() => {
                        dispatch(loadingSpinner(false));
                    }, 500);
                }
            }
        }).catch((error) => {

            if (navigator.onLine) {
                var errorCode = error.hasOwnProperty("response");
                var status = errorCode.hasOwnProperty("status")

                if (!status) {
                    const statusCode = status ? error.response.status: 404;

                    for (const key in itemResponseSets) {
                        if (itemResponseSets.hasOwnProperty(key)) {
                            itemResponseSets[key].hasPosted = 0;
                            itemResponseSets[key].serverStatus = statusCode
                        }
                    }
                    dispatch({
                        "type":ActionType.PUT_ALL_SUCCESS,
                        "data":{itemResponseSets, "status":statusCode}
                    });

                    if (type !== "itemChange") {
                        dispatch(lostConnection(true));
                        dispatch(loadingSpinner(false));
                    }
                }
            } else {
                dispatch({
                    "type":ActionType.LOST_CONNECTION,
                    "data":navigator.onLine
                });
            }
            console.log("Exceptions: while update the item response in the action:_", error);
        })
    }
}

/**
 * Action to put all the item response
 *
 * @param { dataCollectionGuid:object } dataCollectionGuid
 * @param { itemResponseSets:Array } itemResponseSets
 * @param { completion:string } completion
 *
 */
const putAllForMultiple = (dataCollectionGuid, itemResponseSets, completionStatus, type, elapsedTime, itemKey, putAllForMultipleCollection) => {
    return async (dispatch) => {

        surveyServices.putAllForMultiple(dataCollectionGuid, itemResponseSets, completionStatus, elapsedTime, putAllForMultipleCollection).then((response) => {
            if (typeof response.status !== undefined) {

                for (const key in itemResponseSets) {
                    if (itemResponseSets.hasOwnProperty(key)) {
                        itemResponseSets[key].hasPosted = 1;
                        itemResponseSets[key].serverStatus = response.status;
                    }
                }

                dispatch({
                    "type":ActionType.PUT_ALL_SUCCESS,
                    "data":{itemResponseSets, "status":response.status}
                });

                dispatch({
                    "type":ActionType.PUT_ALL_SUCCESS_STATUS,
                    "data":response.status
                });

                setTimeout(() => {
                    dispatch(isAPIUpdate(false));
                }, 0);

                if (type !== "itemChange") {
                    dispatch({
                        "type":ActionType.PUT_ALL_RESPONSE,
                        "data":response.data
                    });
                    setTimeout(() => {
                        dispatch(loadingSpinner(false));
                    }, 500);
                }
            }
        }).catch((error) => {
            if (navigator.onLine) {
                var errorCode = error.hasOwnProperty("response");
                var status = errorCode.hasOwnProperty("status")

                if (!status) {
                    const statusCode = status ? error.response.status: 404;

                    for (const key in itemResponseSets) {
                        if (itemResponseSets.hasOwnProperty(key)) {
                            itemResponseSets[key].hasPosted = 0;
                            itemResponseSets[key].serverStatus = statusCode
                        }
                    }
                    dispatch({
                        "type":ActionType.PUT_ALL_SUCCESS,
                        "data":{itemResponseSets, "status":statusCode}
                    });

                    if (type !== "itemChange") {
                        dispatch(lostConnection(true));
                        dispatch(loadingSpinner(false));
                    }
                }
            } else {
                dispatch({
                    "type":ActionType.LOST_CONNECTION,
                    "data":navigator.onLine
                });
            }
            console.log("Exceptions: while update the putAll for multiple response in the action:_", error);
        })
    }
}

/**
 * Action to get get all single response
 *
 * @param { dataCollectionGuid:String } dataCollectionGuid
 *
 */
const getAllResponse = (dataCollectionGuid, session) => {
    return (dispatch) => {
        surveyServices.getAllResponseData(dataCollectionGuid, session).then((response) => {
            dispatch({
                'type':ActionType.GET_ALL_ITEM_RESPONSE,
                'data':response.data
            })
        }).catch((error) => {
            console.log("Exceptions: while getting all response in the action:_", error);
        })
    }
}

/**
 * Action to get all question list.
 *
 * @param { itemList:Array } itemList
 * @returns { object } object
 */
const getQuestionList = (itemList) => {
    return (dispatch) => {
        dispatch({
            'type':ActionType.GET_ITEMS,
            'data':itemList
        });
    }
}

/**
 * Action to get given answered count
 *
 * @param {answeredQuestion:Number} answeredQuestion
 * @return { Number } return count
 *
 */
const getAnsweredQuestionCount = (answeredQuestion) => {
    return (dispatch) => {
        dispatch({
            'type':ActionType.GET_ANSWERED_QUESTION,
            'data':answeredQuestion
        });
    }
}

/**
 * Action to get element id
 *
 * @param { questionId:string } questionId
 * @returns { string } element id
 *
 */
const scrollToQuestion = (questionId) => {
    return (dispatch) => {
        dispatch({
            'type':ActionType.SCROLL_TO_QUESTION,
            'data':questionId
        });
    }
}

/**
 * Action to reset slider value
 *
 * @param {*} requestParameter
 */
const resetSingleItemSlider = (requestParameter) => {
    return (dispatch) => {
        dispatch({
            'type':ActionType.SINGLE_ITEM_RESET_SLIDER,
            'data':requestParameter
        });
    }
}


/**
 * Action to reset point assignment slider value
 *
 * @param {*} requestParameter
 */
const resetPointAssSlider = (requestParameter) => {
    return (dispatch) => {
        dispatch({
            'type':ActionType.POINT_ASSIGNMENT_RESET_SLIDER,
            'data':requestParameter
        });
    }
}

/**
 * Action to reset point assignment slider value
 *
 * @param {*} requestParameter
 */
const resetInfiniteSlider = (requestParameter) => {
    return (dispatch) => {
        dispatch({
            'type':ActionType.INFINITE_RESET_SLIDER,
            'data':requestParameter
        });
    }
}

/**
 * Action to get instrument
 *
 * @param {*} requestData
 */
const getInstrument = (requestData) => {
    return (dispatch) => {
        dispatch({
            'type':ActionType.LOAD_INSTRUMENT,
            'data':requestData
        });
    }
}

/**
 * Action to handle connection lost
 *
 */
const lostConnection = (flag) => ({
    type:ActionType.LOST_CONNECTION,
    data:flag
});

/**
 * Action to display loading indicators
 *
 */
const loadingSpinner = (flag) => ({
    type:ActionType.LOADER,
    data:flag
});


/**
 * Action to display item loading indicators
 *
 */
const loadingItemSpinner = (flag) => ({
    type:ActionType.SPINNER,
    data:flag
});

/**
 * Action to display item loading indicators
 *
 */
const isAPIUpdate = (flag) => ({
    type:ActionType.IS_API_UPDATE,
    data:flag
});


export {
    getSessionHeader,
    getSurvey,
    getAssessmentInfoForDataCollection,
    getAssessmentInfosForDataCollection,
    putAllItemResponses,
    putAllForMultiple,
    getAllResponse,
    getQuestionList,
    getAnsweredQuestionCount,
    scrollToQuestion,
    resetSingleItemSlider,
    resetPointAssSlider,
    resetInfiniteSlider,
    getInstrument,
    loadingSpinner,
    loadingItemSpinner,
    lostConnection,
    isAPIUpdate
}
